import React, { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import CountUp from 'react-countup';
import { motion } from 'framer-motion';
import { fadeIn } from '../variants';
import { Link } from 'react-scroll';
import ParallaxAnimation from './ParallaxAnimation';
import TextAnimation from './textAnimation';


import aboutHorizontalScrollImage from '../img/2078BurningChicagoOrange03.png';
import aboutHorizontalScrollImage01 from '../img/blazingPirateShip02.jpg';
import aboutVerticallScrollImage02 from '../img/blazingTower01.png';
import aboutVerticalScrollImage03 from '../img/blazingsword.jpg';

const About = () => {
    const { ref, inView } = useInView({ threshold: 0.1 });

    // État pour gérer si l'appareil est mobile ou non, basé sur la largeur de la fenêtre
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1080);
    const [isSmallScreen, setIsSmallScreen] = useState(false);
    const [remountKey, setRemountKey] = useState(0);

    // Choix de l'image de fond en fonction de la date et de la taille de l'écran
    const chooseBackgroundImage = (isEvenDay, isMobileView) => {
        if (isMobileView) {
            return isEvenDay ? aboutVerticallScrollImage02 : aboutVerticalScrollImage03;
        } else {
            return isEvenDay ? aboutHorizontalScrollImage : aboutHorizontalScrollImage01;
        }
    };

    // Détermine si le jour est pair ou impair
    const isEvenDay = new Date().getDate() % 2 === 0;

    // État pour gérer l'image de fond actuelle
    const [backgroundImage, setBackgroundImage] = useState(chooseBackgroundImage(isEvenDay, isMobile));

    // Écoutez les changements de taille de la fenêtre et mettez à jour le state `isMobile`
    useEffect(() => {
        const handleResize = () => {
            const currentIsMobile = window.innerWidth < 1080;
            setIsMobile(currentIsMobile);
            setBackgroundImage(chooseBackgroundImage(isEvenDay, currentIsMobile));
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [isEvenDay]);

    useEffect(() => {
        // Fonction qui ajuste l'état basé sur la largeur de la fenêtre
        const handleResize = () => {
          setIsSmallScreen(window.innerWidth <= 767);
        };
      
        // Vérifiez immédiatement et ensuite à chaque redimensionnement
        handleResize();
        window.addEventListener('resize', handleResize);
      
        // Nettoyage de l'écouteur d'événements
        return () => window.removeEventListener('resize', handleResize);
      }, []);

      useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth <= 500);
            // Forcer le remontage lorsque la taille de l'écran change
            setRemountKey(prevKey => prevKey + 1);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <section className="section h-auto bg-site1 bg-cover" id='about' ref={ref} style={{ block: "center", behavior: "smooth", inline: "center", height: '100%', width: '100%' }}>
            <ParallaxAnimation isMobile={isMobile}
                backgroundImage={backgroundImage}
                backgroundPositionX={isMobile ? '0px' : '100vw'}
                backgroundPositionY={isMobile ? '50vh' : '0px'}
                backgroundSize={isMobile ? '100% 200%' : '200% 100%'}
                trigger="#about"
                style={{ marginTop: isMobile ? 'calc(55.25vh + 15rem)' : '55.25vh' }}
            >
                <div className='flex flex-row justify-around items-center reveal2Container'>
                    <TextAnimation
                        key={remountKey}
                        inView={inView}
                        trigger="#about"
                        variants={fadeIn("up", 0.8)}
                        initial="hidden"
                        animate="show"
                        viewport={{ once: false, amount: 0.7 }}
                    >
                        <div className=' flex flex-col justify-center items-center scroll-reveal2'
                            style={{
                                display: 'flex',
                                alignContent: 'center',
                                position: 'relative',
                                textAlign: 'center',
                                justifyContent: 'center',
                                width: 'contain',
                                height: 'auto',
                                backgroundImage: `linear-gradient(90deg, #FFF, #B4571C)`,
                                backgroundClip: 'text',
                                color: 'transparent',
                                backgroundSize: '0% 100%',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                padding: '1rem',
                            }}
                        >
                            <h2>Découvrez Mon Expertise</h2>
                            <p>En tant que développeur web déterminé et passionné, je façonne l'expérience numérique avec finesse et innovation...</p>
                        </div>
                </TextAnimation>
                </div>
            </ParallaxAnimation>
            <div className='container mx-auto lg:ml-[-35vw] lg:mt-[-20vh] px-4 lg:px-0 lg:min-w-[50vw]' style={{ display: 'flex', width: '100%', height: '100%' }}>
                <div className='flex lg:flex-row flex-col justify-between items-center lg:items-start gap-10 lg:gap-20 h-full'>
                    {/* Contenu de gauche (image ou autre) */}
                    <motion.div
                        variants={fadeIn("left", 0.5)}
                        initial="hidden"
                        animate="show"
                        className='flex-1 flex flex-col gap-y-6 items-start'
                        // style={{ marginBottom: 'isSmallScreen ? -35vh : 0' }}
                    >
                        {/* Insérez ici le contenu de gauche si nécessaire */}
                    </motion.div>

                    {/* Contenu de droite (textes et compteurs) */}
                    <motion.div
                        variants={fadeIn("right", 0.5)}
                        initial="hidden"
                        animate="show"
                        className='flex-1 flex flex-col gap-y-6 items-start decritpionAboutMe jstify-center items-center'
                        style={{ height: '100%'}}
                    >
                        {/* Titre, sous-titre et paragraphe */}
                        <h2 className='text-5xl 2xl:text-4xl xl:text-4xl lg:text-3xl md:text-3xl sm:text-3xl xs:text-2xl xxs:text-2xl xxxs:text-2xl xxxxs:text-xl font-bold text-brown-700 uppercase mb-8 mt-8 lg:mt-0 lg:h-[55vh] lg:pt-[32rem]' style={{ color: '#F5981D', fontWeight: '700', textTransform: 'uppercase' }}>À propos de moi</h2>
                        <h3 className='text-xl xxs:text-lg xxxs:text-base xxxs:text-base xxxxs:text-base font-bold text-orange-500 uppercase mb-4 lg:mb-8 xxs:mt-6 leading-tight sm:leading-snug md:leading-normal lg:leading-relaxed xxxxs:ml-10'>Je suis un développeur web fullstack freelance avec 4 années d'expérience.</h3>
                        <p className='mb-6' style={{ backgroundColor: 'rgba(0,0,0, 0.5)' }}>
                            En tant que développeur web fullstack freelance, j'ai acquis une solide expérience au cours de ces deux dernières années. Mon parcours m'a permis de maîtriser les aspects techniques et esthétiques du développement web. Je suis passionné par la création d'expériences utilisateur exceptionnelles en combinant mon expertise en HTML, CSS, JavaScript et d'autres technologies comme React, Angular, Tailwind et bien d'autres. Mon objectif est de concevoir des sites web innovants et fonctionnels qui répondent aux besoins de mes clients tout en privilégiant une esthétique soignée. Mon portfolio est le reflet de mon engagement envers l'excellence dans le monde du développement web.
                        </p>

                        {/* Conteneur pour les compteurs */}
                        <div className='flex flex-row justify-around items-center w-full compteurAbout'>
                            {/* Compteur Années d'expérience */}
                            <div className='text-center'>
                                <h3 className='text-5xl xs:text-3xl xxs:text-2xl xxxs:text-xl xxxxs:text-xl font-semibold text-orange-500'>
                                    {inView ? <CountUp end={4} duration={3.5} /> : '0'}
                                </h3>
                                <p className='pAboutCount pAboutCountA text-2xl xs:text-xl xxs:text-lg xxxs:text-sm xxxxs:text-sm text-brown-700'>Années d'expérience</p>
                            </div>

                            {/* Compteur Projets complétés */}
                            <div className='text-center'>
                                <h3 className='text-5xl xs:text-3xl xxs:text-2xl xxxs:text-xl xxxxs:text-xl font-semibold text-orange-500'>
                                    {inView ? <CountUp end={220} duration={3.5} /> : '0'}
                                </h3>
                                <p className='pAboutCount text-2xl xs:text-xl xxs:text-lg xxxs:text-sm xxxxs:text-sm text-brown-700'>Projets complétés</p>
                            </div>

                            {/* Compteur Clients satisfaits */}
                            <div className='text-center'>
                                <h3 className='text-5xl xs:text-3xl xxs:text-2xl xxxs:text-xl xxxxs:text-xl font-semibold text-orange-500'>
                                    {inView ? <CountUp end={15} duration={3.5} /> : '0'}
                                </h3>
                                <p className='pAboutCount pAboutCountC text-2xl xs:text-xl xxs:text-lg xxxs:text-sm xxxxs:text-sm text-brown-700'>Clients satisfaits</p>
                            </div>
                        </div>
                        <motion.div
                            variants={fadeIn("up", 0.8)}
                            initial="hidden"
                            whileinView="show"
                            viewport={{ once: false, amount: 0.7 }}
                            className='flex gap-x-6 xxs:gap-x-4 items-center buttonAboutMe'
                        >
                            <Link to="contact" spy={true} smooth={true} offset={-70} duration={500}
                                className="btnBase4 btn-lg lg:btn-lg md:btn-md sm:btn-sm xs:btn-xs xxs:btn-xxs xxxs:btn-xxxs xxxxs:btn-xxxs flex items-center justify-center"
                            >
                                Contactez-moi
                            </Link>
                            <a href="https://www.youtube.com/channel/UCQ6Zr5qXWZqkXZ5r9ZbQY0w" target="_blank" rel="noreferrer"
                                className="font-bold text-2xl text-[#F5981D] hover:text-[#875410] transition duration-300 ease-in-out"
                            >
                                Mon Portfolio
                            </a>
                        </motion.div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default About;





















